export var SDK_VERSION = '6.19.4';
//# sourceMappingURL=version.js.map